import { isPlatformBrowser } from '@angular/common';
import {
  DOCUMENT,
  Injectable,
  PLATFORM_ID,
  inject,
  signal
} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarMenuStateService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly document = inject(DOCUMENT);

  private isCollapsedSignal = signal(true);
  readonly isCollapsed = this.isCollapsedSignal.asReadonly();

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const view = this.document.defaultView;
      if (!view) {
        return;
      }

      const resetFromPageLifecycle = () => this.collapse();

      view.addEventListener('pagehide', resetFromPageLifecycle);
      view.addEventListener('pageshow', resetFromPageLifecycle);
      this.document.addEventListener('freeze', resetFromPageLifecycle);
      this.document.addEventListener('resume', resetFromPageLifecycle);
    }
  }

  toggleCollapse() {
    this.isCollapsedSignal.update((prev) => !prev);
  }

  collapse(): void {
    this.isCollapsedSignal.set(true);
  }
}
